export default __webpack_public_path__ + "static/media/blog-thumbnail.1aa882c6.jpg";